import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "expanding-gcc-operations-in-hyderabad": {
    id: 1,
    title: "Global Capability Centers Hyderabad",
    category: "Global Capability Centers",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "July 30, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Explore why U.S. companies are expanding Global Capability Centers in Hyderabad, leveraging skilled talent, technology, innovation, and cost advantages.",
    content: [
      {
        type: "heading2",
        text: "Why U.S. Companies Are Expanding GCC Operations in Hyderabad",
      },
      {
        type: "paragraph",
        text: 'As U.S. businesses accelerate digital transformation and global expansion,  <a href="https://techprojects.com/services/gcc" class="text-blue-600 hover:text-blue-800">Global Capability Centers in Hyderabad </a>have become a strategic investment for driving innovation, operational excellence, and business growth. Hyderabad has evolved from an IT outsourcing destination into one of India leading technology and innovation hubs, attracting multinational corporations across industries such as banking, healthcare, manufacturing, retail, and technology.',},
  
    {
        type: "paragraph",
        text: "Today, U.S. companies are establishing Global Capability Centers (GCCs) in Hyderabad to build engineering teams, develop AI-powered solutions, modernize enterprise applications, and improve customer experiences. With access to a highly skilled workforce, world-class infrastructure, and a supportive business environment, Hyderabad offers everything global enterprises need to scale efficiently.",},
    {
        type: "heading2",
        text: "Access to a Highly Skilled Talent Pool",
      },
      {
        type: "paragraph",
        text: "One of the primary reasons U.S. companies choose Global Capability Centers in Hyderabad is the city's exceptional talent ecosystem. Hyderabad is home to thousands of experienced professionals specializing in software engineering, artificial intelligence (AI), cloud computing, cybersecurity, data analytics, DevOps, and enterprise technologies."
    },
    {
        type: "paragraph",
        text: "The city's universities and technical institutions produce a steady pipeline of skilled graduates, enabling organizations to recruit top talent and rapidly expand their teams. This availability of experienced professionals helps businesses accelerate product development while maintaining high-quality standards."
    },
      {
        type: "heading2",
        text: "Cost-Effective Operations Without Compromising Quality",
      },
      {
        type: "paragraph",
        text: "Hyderabad provides a significant cost advantage compared to operating technology teams in the United States and many other global markets. Companies benefit from competitive operating costs, modern commercial infrastructure, and access to skilled professionals without sacrificing quality or innovation."
    },
    {
        type: "paragraph",
        text: "These cost efficiencies allow organizations to invest more in research, product development, cloud modernization, and AI initiatives, making GCCs strategic growth centers rather than just cost-saving operations."
    },
    {
        type: "heading2",
        text: "A Thriving Technology and Innovation Ecosystem",
      },
      {
        type: "paragraph",
        text: "Hyderabad has become one of India's fastest-growing technology hubs, supported by global enterprises, innovative startups, research institutions, and modern business infrastructure. The city offers an ideal environment for companies looking to build innovation-driven GCCs focused on digital engineering, enterprise applications, automation, and emerging technologies."
    },
    {
        type: "paragraph",
        text: "This collaborative ecosystem enables businesses to work closely with technology partners, recruit specialized talent, and accelerate innovation across global operations."
    },
    {
        type: "heading2",
        text: "Why TechProjects Is the Preferred GCC Consulting Partner",
      },
      {
        type: "paragraph",
        text: 'Establishing a successful GCC requires careful planning, technology expertise, and a long-term growth strategy. TechProjects has emerged as one of the trusted  <a href="https://techprojects.com/services/gcc" class="text-blue-600 hover:text-blue-800">GCC consulting companies Hyderabad </a>enterprises rely on to establish and scale Global Capability Centers.',},
    {
        type: "paragraph",
        text: "TechProjects provides end-to-end GCC consulting services, helping organizations design, implement, and optimize their operations. From strategic planning and IT consulting to cloud migration, Oracle Cloud services, cybersecurity, digital transformation, enterprise applications, and IT staffing, TechProjects delivers comprehensive solutions tailored to business objectives."
    },
    {
        type: "paragraph",
        text: "By understanding each organization's operational and technology requirements, TechProjects enables businesses to launch scalable, secure, and future-ready GCCs while reducing implementation risks and accelerating time-to-value."
    },
    {
        type: "heading2",
        text: "Business-Friendly Environment and Modern Infrastructure",
      },
      
    {
        type: "paragraph",
        text: "Hyderabad offers excellent infrastructure that supports large-scale business operations. The city features Grade-A office spaces, reliable digital connectivity, international airport access, modern transportation, and well-developed commercial districts such as HITEC City, Gachibowli, and the Financial District."
    },
    {
        type: "paragraph",
        text: "In addition, business-friendly government initiatives and a strong focus on technology investments make Hyderabad an attractive destination for multinational companies expanding their global operations."
    },
    {
        type: "heading2",
        text: "Industries Driving GCC Expansion",
      },
      
    {
        type: "paragraph",
        text: "Several sectors are driving the growth of Global Capability Centers Hyderabad, including:"
    },
    {
        type: "bulletList",
        items: [
          "Information Technology",
          "Banking and Financial Services",
          "Healthcare and Life Sciences",
          "Manufacturing",
          "Retail and E-commerce",
          "Automotive",
          "Telecommunications",
          "Semiconductor",
          "Insurance"
         
        ],
      },
      {
        type: "paragraph",
        text: "These organizations leverage Hyderabad's skilled workforce and innovation ecosystem to manage mission-critical business functions, develop new technologies, and deliver better customer experiences worldwide."
    },
      {
        type: "heading2",
        text: "Choosing the Right GCC Consulting Company",
      },
      {
        type: "paragraph",
        text: "While Hyderabad provides the ideal location for GCC expansion, selecting the right consulting partner is equally important. Among the leading GCC consulting companies Hyderabad, TechProjects stands out by offering strategic consulting, enterprise technology expertise, and end-to-end implementation support.",},
      {
        type: "paragraph",
        text: "Whether an organization is launching its first GCC or expanding an existing center, TechProjects helps streamline every stage of the journey from planning and infrastructure to talent acquisition and digital transformation. This enables businesses to build high-performing Global Capability Centers that support long-term innovation and sustainable growth.",},
        
      
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "The rapid expansion of Global Capability Centers in Hyderabad reflects the city's growing importance as a global technology and innovation hub. U.S. companies are choosing Hyderabad because it offers a unique combination of skilled talent, cost efficiency, advanced infrastructure, and a thriving digital ecosystem.",
      },
      
      {
        type: "heading2",
        text: "Frequently Asked Questions (FAQs) :",
      },
      {
        type: "heading3",
        text: "1. Why are U.S. companies establishing Global Capability Centers in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "U.S. companies choose Global Capability Centers in Hyderabad because of the city's skilled workforce, cost-effective operations, world-class infrastructure, and strong technology ecosystem. Hyderabad also offers excellent connectivity and a business-friendly environment for global enterprises.",
      },
      {
        type: "heading3",
        text: "2. What services do GCC consulting companies in Hyderabad provide?",
      },
      {
        type: "paragraph",
        text: "Leading GCC consulting companies Hyderabad, such as TechProjects, offer end-to-end services including GCC strategy, location planning, IT consulting, cloud migration, digital transformation, cybersecurity, IT staffing, enterprise application implementation, and managed IT services.",
      },
      {
        type: "heading3",
        text: "3. Which industries are investing in Global Capability Centers in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Industries including information technology, banking, healthcare, life sciences, manufacturing, retail, automotive, and financial services are actively investing in Global Capability Centers in Hyderabad to support innovation and global business operations.",
      },
      {
        type: "heading3",
        text: "4. Why should businesses choose TechProjects for GCC consulting?",
      },
      {
        type: "paragraph",
        text: "TechProjects helps organizations establish and scale Global Capability Centers through strategic consulting, cloud solutions, Oracle Cloud services, cybersecurity, digital transformation, enterprise applications, and IT staffing. Its end-to-end approach enables businesses to build secure, scalable, and future-ready GCC operations.",
      },
      {
        type: "heading3",
        text: "5. What are the key benefits of setting up a GCC in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Setting up a GCC in Hyderabad provides access to highly skilled talent, lower operational costs, advanced infrastructure, faster business scalability, and a thriving technology ecosystem. These advantages help organizations improve innovation, operational efficiency, and long-term business growth.",
      },

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["expanding-gcc-operations-in-hyderabad"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Explore why U.S. companies are expanding Global Capability Centers in Hyderabad, leveraging skilled talent, technology, innovation, and cost advantages.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
